(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.directive('emailTable', [EmailTableFn]);

    /* email table directive */
    function EmailTableFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/email/overview/templates/email-table.template.html',
            controller: 'EmailTableController',
            controllerAs: 'vm',
            bindToController: true, 
            scope: {
                emails: '='
            }
        };
        return directive;
    }

})();